"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;
exports.search = search;
exports.create = create;
exports.update = update;
exports.remove = remove;
exports.fetchByIds = fetchByIds;
exports.reviver = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var _ProductRecord = _interopRequireDefault(require("customer-data-objects/product/ProductRecord"));

var _FolderRecord = _interopRequireDefault(require("customer-data-objects/folder/FolderRecord"));

var _ProductQuery = _interopRequireDefault(require("crm_data/products/ProductQuery"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _HTTPVerbs = require("crm_data/constants/HTTPVerbs");

var _PropertySourceTypes = require("customer-data-objects/property/PropertySourceTypes");

var baseUrl = 'inbounddbproducts/v1/products';
var searchUrl = 'folders/v1/search/products';

var headers = function headers(userEmail) {
  return {
    'X-Properties-Source': _PropertySourceTypes.CRM_UI,
    'X-Properties-SourceId': userEmail
  };
};

var reviver = function reviver(response) {
  var resultsRecords = (0, _immutable.List)(response.results ? response.results.map(function (object) {
    return object.objectType === 'PRODUCT' ? _ProductRecord.default.fromJS(object) : _FolderRecord.default.fromJS(object);
  }) : []);
  return (0, _immutable.Map)((0, _extends2.default)({}, response, {
    results: resultsRecords
  }));
};

exports.reviver = reviver;

function fetch() {
  return (0, _ImmutableAPI.get)(baseUrl, {
    includeAllValues: true
  }, reviver);
}

function search() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _ProductQuery.default();
  var offset = query.offset,
      count = query.count,
      sorts = query.sorts,
      filterGroups = query.filterGroups;
  return (0, _ImmutableAPI.send)({
    type: _HTTPVerbs.POST,
    query: {
      includeAllValues: true
    }
  }, searchUrl, {
    query: query.search,
    offset: offset,
    count: count,
    sorts: sorts.toJS(),
    filterGroups: filterGroups.toJS()
  }, reviver);
}

function create(_ref) {
  var payload = _ref.payload,
      userEmail = _ref.userEmail;
  return (0, _ImmutableAPI.send)({
    headers: headers(userEmail),
    type: _HTTPVerbs.POST
  }, baseUrl, {
    object: {
      properties: payload
    }
  }).then(function (result) {
    return _ProductRecord.default.fromJS(result);
  });
}

function update(_ref2) {
  var product = _ref2.product,
      updates = _ref2.updates,
      userEmail = _ref2.userEmail;
  var id = (0, _ImmutableModel.getId)(product);
  return (0, _ImmutableAPI.send)({
    headers: headers(userEmail),
    type: _HTTPVerbs.PUT
  }, baseUrl + "/" + id, {
    productId: id,
    properties: updates
  }).then(function (res) {
    return {
      id: res.get('objectId'),
      nextProperties: res.get('properties')
    };
  });
}

function remove(productIds) {
  if (productIds.length > 1) {
    return (0, _ImmutableAPI.send)({
      type: _HTTPVerbs.DELETE,
      query: {
        id: productIds
      }
    }, baseUrl + "/batch");
  }

  var _productIds = (0, _slicedToArray2.default)(productIds, 1),
      productId = _productIds[0];

  return (0, _ImmutableAPI.del)(baseUrl + "/" + productId);
}

function fetchByIds(ids) {
  var url = 'inbounddbproducts/v1/products/batch';
  return (0, _ImmutableAPI.get)(url, {
    id: ids.toArray(),
    allPropertiesFetchMode: 'latest_version'
  }).then(function (response) {
    return response.map(function (product) {
      return _ProductRecord.default.fromJS(product);
    });
  });
}